import {
  isComparableviyv6ctzm76u as isComparable,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_compare(_this__u8e3s4) {
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = (a, b) => {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = _this__u8e3s4.q4a(a);
    var tmp_0 = (!(tmp == null) ? isComparable(tmp) : false) ? tmp : null;
    var tmp_1 = _this__u8e3s4.q4a(b);
    var tmp$ret$1 = (!(tmp_1 == null) ? isComparable(tmp_1) : false) ? tmp_1 : null;
    return compareValues(tmp_0, tmp$ret$1);
  };
  return new (sam$kotlin_Comparator$0())(tmp);
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.r4q_1 = function_0;
      }
      wi(a, b) {
        return this.r4q_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.r4q_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
//region block: exports
export {
  get_compare as get_compare1s08igku0oz25,
};
//endregion

//# sourceMappingURL=DataClassPath.sort.mjs.map
